import LeftArrow from "../../assets/Home/LeftArrow.svg";
import RightArrow from "../../assets/Home/RightArrow.svg";
import style from "./style.module.css";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
	return (
		<div className={style.Pagination}>
			<button
				onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
				disabled={currentPage === 1}
			>
				<img src={LeftArrow} alt="PreviousArrow" />
			</button>
			{Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
				<button
					key={page}
					onClick={() => onPageChange(page)}
					className={currentPage === page ? style.active : ""}
				>
					{page}
				</button>
			))}
			<button
				onClick={() =>
					onPageChange(Math.min(currentPage + 1, totalPages))
				}
				disabled={currentPage === totalPages}
			>
				<img src={RightArrow} alt="NextArrow" />
			</button>
		</div>
	);
};

export default Pagination;
